module.exports = __webpack_public_path__ + "static/media/outcome.984e6240.png";